<template>
  <div class="container">
    <div class="apply-tab">
      <img @click="handleBack" style="width: 24px; height: 24px" src="../assets/back.png" />
      <div>{{ modelName }}</div>
    </div>
    <div class="content">
      <div class="apply-container">
        <span>提交人:{{ renderStaffName() }}</span>
      </div>
      <van-form ref="form" @submit="submit">
        <div class="form-box" v-for="(originItem, originIndex) in originData" :key="originIndex">
          <div class="form-container">
            <div v-for="(item, index) in getOriginItem(originItem)" :key="index">
              <van-field
                v-if="item.tagIcon === 'input'"
                :label="item.label"
                v-model="fieldsValue[`${item.vModel}`]"
                :placeholder="item.placeholder"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @input="handleInput"
                :disabled="item.disabled"
              />
              <van-field
                v-if="item.tagIcon === 'textarea'"
                type="textarea"
                :label="item.label"
                v-model="fieldsValue[`${item.vModel}`]"
                :placeholder="item.placeholder"
                :required="item.required"
                autosize
                class="inputfield"
                :rules="[{ required: item.required }]"
                maxlength="2000"
                input-align="left"
                show-word-limit
                @input="handleInput"
              />
              <van-field
                v-if="item.tagIcon === 'map'"
                :label="item.label"
                :value="address['address']"
                :placeholder="item.placeholder"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @click="handleMap"
              />
              <van-field
                v-if="item.tagIcon === 'date-range'"
                :label="item.label"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @click="handleRnageTime(item, 'start')"
                :value="startTime"
              />
              <van-field
                v-if="item.tagIcon === 'date-range'"
                :label="item.label"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @click="handleRnageTime(item, 'end')"
                :value="endTime"
              />
              <!-- <van-field
            v-if="item.tagIcon === 'textarea'"
            :label="item.label"
            v-model="fieldsValue[`field${formId}`]"
            :placeholder="item.placeholder"
            :required="item.required"
            :rules="[{required: item.required,message: '请输入内容'}]"
          /> -->
              <van-field v-if="item.tagIcon === 'switch' && kitValue !== 0" :label="item.label" readonly :required="item.required" :rules="[{ required: item.required }]">
                <template #input>
                  <van-switch v-model="fieldsValue[`${item.vModel}`]" @change="changeSwitch" />
                </template>
              </van-field>
              <van-field
                v-if="item.tagIcon === 'switch' && kitValue === 0 && item.label === '是否需要转交审批单'"
                :label="item.label"
                readonly
                :required="item.required"
                :rules="[{ required: item.required }]"
              >
                <template #input>
                  <van-switch v-model="fieldsValue[`${item.vModel}`]" @change="changeSwitch" />
                </template>
              </van-field>
              <van-field
                v-if="item.tagIcon === 'switch' && kitValue === 0 && item.label === '自动抄送转交人' && switchFlag"
                :label="item.label"
                readonly
                :required="item.required"
                :rules="[{ required: item.required }]"
              >
                <template #input>
                  <van-switch v-model="fieldsValue[`${item.vModel}`]" @change="changeSwitch" />
                </template>
              </van-field>
              <van-field
                v-if="item.tag === 'el-date-picker'"
                readonly
                clickable
                right-icon="arrow-down"
                :label="item.label"
                :value="fieldsValue[`${item.vModel}`]"
                :placeholder="item.placeholder"
                @click="handleTime(item, index)"
                :required="item.required"
                :rules="[{ required: item.required }]"
              />
              <van-popup v-model="showPicker" position="bottom" v-if="item.tag === 'el-date-picker'" :key="index">
                <van-datetime-picker
                  :min-date="minDate"
                  :max-date="maxDate"
                  v-if="item.tag === 'el-date-picker'"
                  :type="vanDateType"
                  @confirm="data => onConfirm(data)"
                  @cancel="showPicker = false"
                  v-model="currentDate"
                />
              </van-popup>
              <van-popup v-model="showRangePicker" position="bottom" v-if="item.tagIcon === 'date-range'" :key="index">
                <van-datetime-picker v-if="item.tagIcon === 'date-range'" type="datetime" @confirm="data => onConfirmRangeTime(data)" @cancel="showRangePicker = false" />
              </van-popup>
              <div v-if="item.tag === 'el-upload'">
                <van-field
                  v-if="item.tag === 'el-upload'"
                  name="uploader"
                  :label="item.label"
                  :placeholder="item.placeholder"
                  :required="item.required"
                  v-model="fieldsValue[`${item.vModel}`]"
                  :rules="[{ required: item.required }]"
                >
                  <template #input>
                    <van-uploader
                      v-if="item.tag === 'el-upload'"
                      :before-read="beforeRead"
                      :after-read="file => afterRead(file, item)"
                      :before-delete="file => beforeDelete(file, item)"
                      v-model="fileList"
                      accept="*"
                      multiple
                      :preview-image="false"
                    >
                      <template>
                        <div>
                          <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
                        </div>
                      </template>
                    </van-uploader>
                  </template>
                </van-field>
                <div v-for="(i, index) in fileList" :key="index" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 16px">
                  <div class="annex-name" @click="preview(i.url)">
                    <img style="width: 22px; height: 20px; margin-right: 8px" src="../assets/file@2x.png" />
                    <div style="display: flex; flex-direction: column">
                      <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{ renderFileName(i) }}</div>
                      <div>{{ formatSize(i) }}</div>
                    </div>
                  </div>
                  <div class="annex-button" @click="deleteFile(item, i)">删除</div>
                </div>
              </div>
              <van-field
                :placeholder="item.placeholder"
                v-if="item.tag === 'el-input-number'"
                v-model="fieldsValue[`${item.vModel}`]"
                type="number"
                :label="item.label"
                :required="item.required"
                @input="getLinks"
                :rules="[{ required: item.required }]"
              >
                <template #extra v-if="item.label === '时长' || item.label === '请假天数'">
                  <div v-if="item.label === '时长'">小时</div>
                  <div v-if="item.label === '请假天数'">天</div>
                </template>
              </van-field>
              <van-field
                :placeholder="item.placeholder"
                v-if="item.tag === 'fc-amount'"
                v-model="fieldsValue[`${item.vModel}`]"
                type="number"
                :label="item.label"
                :required="item.required"
                @input="getLinks"
                :rules="[{ required: item.required }]"
              />
              <van-field
                readonly
                v-if="item.tagIcon === 'select'"
                clickable
                name="picker"
                :value="selectValue || fieldsValue[`${item.vModel}`]"
                :label="item.label"
                :placeholder="item.placeholder"
                @click="handleSelectValue(item)"
                :required="item.required"
                :rules="[{ required: item.required }]"
              />
              <van-popup v-if="item.tagIcon === 'select'" v-model="showSelect" position="bottom">
                <van-picker v-if="item.tagIcon === 'select'" show-toolbar :columns="columns" @confirm="value => selectConfirm(value)" @cancel="showSelect = false" />
              </van-popup>
              <van-field
                v-if="item.tagIcon === 'cascader'"
                v-model="fieldsValue[`${item.vModel}`]"
                readonly
                :label="item.label"
                :placeholder="item.placeholder"
                @click="show = true"
                :required="item.required"
                :rules="[{ required: item.required }]"
              />
              <van-popup v-if="item.tagIcon === 'cascader'" v-model="show" round position="bottom">
                <van-cascader
                  v-if="item.tagIcon === 'cascader'"
                  v-model="cascaderValue"
                  :options="handleOptions(item)"
                  @close="show = false"
                  @finish="({ selectedOptions }) => onFinish(selectedOptions, item)"
                />
              </van-popup>
              <van-field
                v-if="item.tagIcon === 'area'"
                readonly
                clickable
                name="area"
                :value="fieldsValue[`${item.vModel}`]"
                :label="item.label"
                :placeholder="item.placeholder"
                @click="showArea = true"
                :required="item.required"
                :rules="[{ required: item.required }]"
              />
              <van-popup v-model="showArea" position="bottom" v-if="item.tagIcon === 'area'">
                <van-area :area-list="areaList" @confirm="values => areaOnConfirm(values, item)" @cancel="showArea = false" />
              </van-popup>
              <van-field v-if="item.tag === 'el-radio-group'" name="radio" :label="item.label" :placeholder="item.placeholder" :required="item.required" :rules="[{ required: item.required }]">
                <template #input>
                  <van-radio-group v-model="fieldsValue[`${item.vModel}`]" direction="horizontal">
                    <van-radio v-for="(i, index) in item.options" :name="i.value" :key="index">{{ i.label }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field v-if="item.tag === 'el-slider'" name="slider" :label="item.label" :required="item.required" :rules="[{ required: item.required }]">
                <template #input>
                  <van-slider v-model="fieldsValue[`${item.vModel}`]" />
                </template>
              </van-field>
              <van-field v-if="item.tag === 'el-checkbox-group'" name="checkboxGroup" :label="item.label" :required="item.required" :rules="[{ required: item.required }]">
                <template #input>
                  <van-checkbox-group v-model="fieldsValue[`${item.vModel}`]" direction="horizontal">
                    <van-checkbox v-for="(i, index) in item.options" :name="i.value" :key="index" shape="square">{{ i.value }}</van-checkbox>
                  </van-checkbox-group>
                </template>
              </van-field>
              <van-field v-if="item.tag === 'el-rate'" name="rate" :label="item.label" :required="item.required" :rules="[{ required: item.required }]">
                <template #input>
                  <van-rate v-model="fieldsValue[`${item.vModel}`]" />
                </template>
              </van-field>
              <van-field
                v-if="item.tagIcon === 'dept' && kitValue !== 0"
                name="dept"
                :label="item.label"
                :required="item.required"
                right-icon="arrow"
                :rules="[{ required: item.required }]"
                @click="selectDept(item)"
                :value="handleDept(item)"
                :placeholder="item.label"
              ></van-field>
              <van-field
                v-if="item.tagIcon === 'dept' && kitValue === 0 && item.isKit === 0 && item.label === '接收人' && switchFlag"
                name="dept"
                right-icon="arrow"
                :label="item.label"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @click="selectDept(item)"
                :value="handleDept(item)"
                :placeholder="item.label"
              ></van-field>
              <van-field
                v-if="item.tagIcon === 'position'"
                name="position"
                right-icon="arrow"
                :label="item.label"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @click="selectPosition(item)"
                :value="handlePosition(item)"
              ></van-field>
              <van-field
                v-if="item.tagIcon === 'department'"
                name="department"
                right-icon="arrow"
                :label="item.label"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @click="selectDepartment(item)"
                :value="handleDepartment(item)"
              ></van-field>
              <van-field
                v-if="item.tagIcon === 'company'"
                name="company"
                right-icon="arrow"
                :label="item.label"
                :required="item.required"
                :rules="[{ required: item.required }]"
                @click="selectCompany(item)"
                :value="handleCompany(item)"
              ></van-field>
            </div>
          </div>
        </div>
      </van-form>
      <div class="process-box">
        <div style="font-size: 16px; color: #333333; line-height: 22px; margin-bottom: 10px; font-weight: 500">流程</div>
        <div class="process-start">
          <div style="display: flex">
            <div style="width: 0.6rem">
              <div class="circular"></div>
              <div class="strip"></div>
            </div>
            <div>
              <div style="color: #333333; font-size: 14px">发起申请</div>
              <div style="color: #666666; font-size: 12px">{{ initialData.name }}</div>
            </div>
          </div>
        </div>
        <div
          :class="{
            'process-start': true,
            'process-end': index === linkData.links.length - 1
          }"
          v-for="(item, index) in linkData.links"
          :key="index"
        >
          <div style="display: flex">
            <div style="width: 0.6rem">
              <div class="circular"></div>
              <div class="strip" v-if="index < linkData.links.length - 1" :style="handleStrip(item, index)"></div>
            </div>
            <div>
              <div v-if="item.userType === 'approver'" style="color: #333333; font-size: 14px">
                <span v-if="item.approvalMemberType === 'position'">{{ item.members[0].position }}</span>
                <span v-else>
                  <span v-if="kitValue == 99">接收人</span>
                  <span v-else>审批人</span>
                </span>
              </div>
              <div v-else style="color: #333333; font-size: 14px">
                <span v-if="item.approvalMemberType === 'position'">{{ item.members[0].position }}</span>
                <span v-else>办理人</span>
              </div>
              <div class="select-number">{{ handleSelectNumber(item, index) }}</div>
            </div>
            <div class="approve-alreadySelect" v-if="item.approvalMemberType !== 'optional'">
              <div style="margin-right: 0.2rem; width: 1.4rem; display: flex; flex-direction: column; align-items: center; text-align: center" v-for="(i, index1) in item.members" :key="index1">
                <img v-if="i.avatar" class="member-img" :src="i.avatar" />
                <!-- <div class="staffNameBox" v-else>
                    {{ i.staffName.substring(i.staffName.length - 2) }}
                  </div> -->
                <img src="@/assets/default.png" class="member-img" v-else />
                <div class="member-name">{{ i.staffName }}</div>
              </div>
            </div>
            <div v-if="selectedList[`approve${index}`]" class="approve-list">
              <div v-for="i in selectedList[`approve${index}`]" :key="i.staffId">
                <div class="selected-member">
                  <img v-if="i.avatar" class="member-img" :src="i.avatar" />
                  <!-- <div v-else class="staffNameBox">{{ i.staffName.substring(i.staffName.length - 2) }} </div> -->
                  <img src="@/assets/default.png" class="member-img" v-else />
                  <div class="member-delete" @click="deleteMember(i, `approve${index}`)">-</div>
                  <div class="member-name">{{ i.staffName }}</div>
                </div>
              </div>
            </div>
            <div class="member-plus" v-if="item.approvalMemberType === 'optional'" @click="selectApprove(index)">
              <!-- <img src="@/assets/plus.png" /> -->
              <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
            </div>
            <!-- <img
            class="member-img"
            :src="renderImg(item)"
            v-if="
              item.approvalMemberType !== 'optional' &&
              handleVisible(item.avatar)
            "
          />
          <div
            v-if="
              item.approvalMemberType !== 'optional' &&
              !handleVisible(item.avatar)
            "
            class="member-bg"
          >
            {{ renderMemberName(item) }}
          </div> -->
          </div>
        </div>
      </div>
      <div class="copy-box">
        <div style="font-size: 0.43rem; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333; margin-bottom: 0.48rem">抄送人</div>
        <div class="copy-surround">
          <!-- <div class="copy-alreadySelect" v-if="copyLinkList.length > 0"> -->
          <div class="copy-member" v-for="(item, index) in copyLinkList" :key="index">
            <img v-if="item.avatar" class="member-img" :src="item.avatar" />
            <!-- <div class="staffNameBox" v-else>
                  {{ item.staffName.substring(item.staffName.length - 2) }}
              </div> -->
            <img src="@/assets/default.png" class="member-img" v-else />
            <div class="member-name">{{ item.staffName }}</div>
          </div>
          <!-- </div> -->
          <!-- <div class="copy-list"> -->
          <div v-for="i in selectedList.copy" :key="i.staffId">
            <div class="selected-member">
              <img v-if="i.avatar" class="member-img" :src="i.avatar" />
              <!-- <div class="staffNameBox" v-else>
                  {{ i.staffName.substring(i.staffName.length - 2) }}
                </div> -->
              <img src="@/assets/default.png" class="member-img" v-else />
              <div class="member-delete" @click="deleteMember(i, 'copy')">-</div>

              <div class="member-name">{{ i.staffName }}</div>
            </div>
          </div>
          <!-- </div> -->
          <div style="cursor: pointer" v-if="userOptional" @click="selectCopy">
            <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
            <div style="font-size: 0.27rem; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #666666">请添加</div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-box">
      <van-button @click="save('save')" :loading="saveDraftLoading" :disabled="uploadFileFlag" class="button1">保存到草稿</van-button>
      <van-button @click="send('add')" :loading="submitLoading" :disabled="uploadFileFlag" class="button2">提交</van-button>
    </div>
    <van-popup class="uploading_popup" v-model="uploadFileFlag" round>
      <van-loading size="24px">文件上传中...</van-loading>
    </van-popup>
  </div>
</template>
<script>
import { submitFormData, getModelDetails, upload, getApproveAndCopy, getApplyInfo, getHoliday, computeTime, computeTimeV2, computeTimeV3, uploadList } from '../axios/services';
import { mapState, mapMutations } from 'vuex';
import { areaList } from '@vant/area-data';
import { Toast } from 'vant';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { formatSize } from '../utils';

export default {
  name: 'ApplyForm',
  components: {},
  data() {
    return {
      fileList: [],
      showPicker: false,
      showRangePicker: false,
      rangeStatus: '',
      showSelect: false, // 下拉选择
      show: false,
      showArea: false,
      cascaderValue: '',
      fieldsValue: {},
      areaList,
      submitLoading: false,
      saveDraftLoading: false,
      linkData: {},
      userOptional: false,
      copyLinkList: [],
      copy: [],
      files: [],
      timeIndex: '',
      action: '', // 判断是提交还是保存草稿
      modelId: '',
      startTime: '',
      endTime: '',
      initAvatar: '',
      againSubmitFlag: false,
      modelName: '', // 模板名称
      addressView: '', // 地图
      kitValue: '',
      switchFlag: false,
      columns: [], // 下拉选择框的值
      columnValues: [],
      selectValue: '', // 下拉选择的文本
      originData: [], // 原始表单数据
      startDate: '', // 计算请假时长的开始时间
      endDate: '', // 计算请假时长的结束时间
      leaveCode: '', // 请假类型
      minDate: new Date(1980, 0, 1),
      maxDate: new Date(new Date().getFullYear() + 10, 11, 31),
      department: {}, // 储存部门信息
      uploadFileFlag: false,
      fileModel: {},
      cpmember: [], // 抄送人累加初始
      routeCompanyId: '', // 从url上去获取
      routeToken: '',
      routeNick: '',
      vanDateType: 'datetime'
    };
  },
  watch: {
    linkData(val) {
      this.copyLinkList = val?.copyLink?.members;
      this.initAvatar = val?.initiator?.avatar;
      this.userOptional = val?.copyLink.userOptional;
      this.cpmember = JSON.parse(JSON.stringify(val?.copyLink?.members)); // 初始抄送人中间商
    }
  },
  computed: {
    ...mapState(['initialData', 'formData', 'selectedList', 'status', 'address', 'addressList', 'fromApp'])
  },
  methods: {
    ...mapMutations(['setCheckedList', 'setStatus', 'clearSelectedList', 'setSelectedList', 'setMaxNum', 'setAddressData', 'setInitialData']),
    preview(param) {
      if (param.indexOf('.rar') != -1 || param.indexOf('.zip') != -1) {
        return Toast.fail('该文件不支持预览');
      }
      window.location.href = 'jsToOc://fujianJump?url=' + param;
    },
    strMapList() {
      let str = '';
      this.addressList.forEach((item, value) => {
        str += item.address;
        if (value != this.addressList.length - 1) {
          str += ',';
        }
      });
      // addressList[0]?addressList[0].address:''
      return str;
    },
    dayjs,
    handleInput() {
      this.$forceUpdate();
    },
    getOriginItem(item) {
      return Object.prototype.hasOwnProperty.call(item, 'children') ? item.children : [item];
    },
    renderStaffName() {
      return this.linkData?.initiator?.staffName;
    },
    async getData() {
      console.log(this.initialData, 334);
      if (this.initialData.modelId) {
        await getModelDetails(this.initialData.modelId).then(res => {
          this.kitValue = res.data.data.kitValue;
          this.$store.commit('setKitValue', this.kitValue);
          this.originData = res.data.data.formData.fields; // 将原始表单数据记录下来
          const fields = res.data.data.formData.fields.map(item => {
            if (item.children) {
              item.children.forEach(i => (i.isKit = item.isKit));
              return item.children;
            } else {
              return item;
            }
          });
          this.modelName = res.data.data.modelName;
          this.$store.commit('setFormData', this.flatten(fields));
          this.formData.map(item => {
            if (item.tagIcon === 'date' && item.isKit == 0 && item.label === '补卡时间' && this.initialData.applyTime) {
              const date = this.initialData.applyTime;
              const data = this.dayjs(Number(date)).format('YYYY-MM-DD HH:mm');

              this.fieldsValue[`${item.vModel}`] = data;
            }
            if (item.tagIcon === 'date-range') {
              this.fieldsValue[`${item.vModel}`] = [];
            }
          });
        });
      }
      if (this.initialData.instanceId) {
        const params = {
          instanceId: this.initialData.instanceId,
          companyId: this.initialData.companyId,
          draftFlag: '0'
        };
        await getApplyInfo(params).then(res => {
          if (res.data.code === 0) {
            this.kitValue = res.data.data.kitValue;
            this.$store.commit('setKitValue', this.kitValue);
            this.modelId = res.data.data.modelId;
            this.modelName = res.data.data.modelName;
            this.againSubmitFlag = res.data.data.againSubmitFlag;
            this.originData = res.data.data.modelFields; // 将原始表单数据记录下来
            const fields = res.data.data.modelFields.map(item => {
              if (item.children) {
                item.children.forEach(i => (i.isKit = item.isKit));
                return item.children;
              } else {
                return item;
              }
            });
            this.$store.commit('setFormData', this.flatten(fields));
            this.formData.map(item => {
              if (item.tagIcon === 'date' && item.isKit == 0 && item.label === '补卡时间' && this.initialData.applyTime) {
                const date = this.initialData.applyTime;
                const data = this.dayjs(Number(date)).format('YYYY-MM-DD HH:mm');

                this.fieldsValue[`${item.vModel}`] = data;
              }
              if (item.tagIcon === 'date-range') {
                this.fieldsValue[`${item.vModel}`] = [];
              }
              if (item.fieldType === 'upload') {
                let fileList = item.value?.map(item => ({
                  ...item,
                  key: uuidv4()
                }));
                this.fileList = this.fileList.length > 0 ? this.fileList : fileList;
                this.fieldsValue[`field${item.fieldNo}`] = JSON.stringify(this.fileList);
              }
            });
            res.data.data.fields.forEach(item => {
              if (item.fieldType === 'upload') {
                let fileList = item.value?.map(item => ({
                  ...item,
                  key: uuidv4()
                }));
                this.fileList = this.fileList.length > 0 ? this.fileList : fileList;
                this.fieldsValue[`field${item.fieldNo}`] = JSON.stringify(this.fileList);
              } else if (item.fieldType === 'map') {
                this.fieldsValue[`field${item.fieldNo}`] = item.value;
                this.setAddressData(item.value);
              } else if (item.fieldType === 'dept') {
                // let str = "";
                // item.value?.forEach((i) => {
                //   str += i.name + "/";
                // });
                // this.fieldsValue[`field${item.fieldNo}`] = str.slice(0,-1);
                this.setStatus(`deptfield${item.fieldNo}`);
                if (!this.selectedList[`deptfield${item.fieldNo}`]) {
                  item.value?.forEach(i => {
                    this.setCheckedList({
                      data: i,
                      status: false,
                      number: `deptfield${item.fieldNo}`
                    });
                  });
                }
              } else if (this.kitValue === 0 && item.kitFlag === 1 && item.fieldName === '请假类型') {
                this.selectValue = item.value;
                this.fieldsValue[`field${item.fieldNo}`] = item.fieldValue;
              } else if (item.fieldType === 'select') {
                // this.selectValue = item.value;
                this.fieldsValue[`field${item.fieldNo}`] = item.value;
              } else {
                this.fieldsValue[`field${item.fieldNo}`] = item.value;
              }
            });
          }
        });
      }
      const params = {
        companyId: this.initialData.companyId,
        modelId: this.initialData.modelId || this.modelId
      };
      await getApproveAndCopy(params).then(res => {
        if (res.data.code === 0) {
          this.linkData = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    checkTime(i) {
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    flatten(arr) {
      // 数组扁平化
      let res = [];
      arr.map(item => {
        if (Array.isArray(item)) {
          res = res.concat(this.flatten(item));
        } else {
          res.push(item);
        }
      });
      return res;
    },
    beforeRead(file) {
      this.uploadFileFlag = true;
      console.log(file, 'beforeRead');
      if (Array.isArray(file)) {
        let size = 0;
        let flag = false;
        file.forEach(item => {
          if (
            item.name.indexOf('.doc') != -1 ||
            item.name.indexOf('.docx') != -1 ||
            item.name.indexOf('.ppt') != -1 ||
            item.name.indexOf('.pptx') != -1 ||
            item.name.indexOf('.txt') != -1 ||
            item.name.indexOf('.jpg') != -1 ||
            item.name.indexOf('.jpeg') != -1 ||
            item.name.indexOf('.png') != -1 ||
            item.name.indexOf('.xlsx') != -1 ||
            item.name.indexOf('.xls') != -1 ||
            item.name.indexOf('.pdf') != -1 ||
            item.name.indexOf('.zip') != -1 ||
            item.name.indexOf('.rar') != -1 ||
            item.name.indexOf('.mov') != -1 ||
            item.name.indexOf('.MOV') != -1 ||
            item.name.indexOf('.m4v') != -1 ||
            item.name.indexOf('.avi') != -1 ||
            item.name.indexOf('.mp4') != -1 ||
            item.name.indexOf('.mkv') != -1 ||
            item.name.indexOf('.wmv') != -1 ||
            item.name.indexOf('.webm') != -1
          ) {
            // if (item.size > 300 * 1024 * 1024) {
            //   this.uploadFileFlag = false;
            //   Toast.fail("上传附件大小不能超过300M。");
            //   return false;
            // } else {
            //   return Promise.resolve();
            // }
            size += item.size;
          } else {
            this.uploadFileFlag = false;
            flag = true;
            // Toast.fail("支持文件格式( .doc/.docx/.ppt/.pptx/.txt/.jpg/.jpeg/.png/.xlsx/.xls/.pdf/.zip/.rar)");
            // return false;
          }
        });
        if (flag) {
          Toast.fail('支持文件格式( .doc/.docx/.ppt/.pptx/.txt/.jpg/.jpeg/.png/.xlsx/.xls/.pdf/.zip/.rar/.mov/.m4v/.avi/.mp4/.mkv/.wmv/.webm)');
          return false;
        }
        if (size > 300 * 1024 * 1024) {
          this.uploadFileFlag = false;
          Toast.fail('上传附件大小不能超过300M。');
          return false;
        } else {
          return Promise.resolve();
        }
      } else {
        if (
          file.name.indexOf('.doc') != -1 ||
          file.name.indexOf('.docx') != -1 ||
          file.name.indexOf('.ppt') != -1 ||
          file.name.indexOf('.pptx') != -1 ||
          file.name.indexOf('.txt') != -1 ||
          file.name.indexOf('.jpg') != -1 ||
          file.name.indexOf('.jpeg') != -1 ||
          file.name.indexOf('.png') != -1 ||
          file.name.indexOf('.xlsx') != -1 ||
          file.name.indexOf('.xls') != -1 ||
          file.name.indexOf('.pdf') != -1 ||
          file.name.indexOf('.zip') != -1 ||
          file.name.indexOf('.rar') != -1 ||
          file.name.indexOf('.mov') != -1 ||
          file.name.indexOf('.MOV') != -1 ||
          file.name.indexOf('.m4v') != -1 ||
          file.name.indexOf('.avi') != -1 ||
          file.name.indexOf('.mp4') != -1 ||
          file.name.indexOf('.mkv') != -1 ||
          file.name.indexOf('.wmv') != -1 ||
          file.name.indexOf('.webm') != -1
        ) {
          if (file.size > 300 * 1024 * 1024) {
            this.uploadFileFlag = false;
            Toast.fail('上传附件大小不能超过300M。');
            return false;
          } else {
            return Promise.resolve();
          }
        } else {
          this.uploadFileFlag = false;
          Toast.fail('支持文件格式( .doc/.docx/.ppt/.pptx/.txt/.jpg/.jpeg/.png/.xlsx/.xls/.pdf/.zip/.rar/.mov/.m4v/.avi/.mp4/.mkv/.wmv/.webm)');
          return false;
        }
      }
    },
    afterRead(file, item) {
      console.log(file, 'afterRead');
      if (Array.isArray(file)) {
        let formData = new FormData();
        file.forEach(item => {
          formData.append('file', item.file);
        });
        uploadList(formData).then(res => {
          this.uploadFileFlag = false;
          // this.fileList = this.fileList?.map((item, index) => {
          //   if (Object.prototype.hasOwnProperty.call(item, "file")) {
          //     return { ...res.data.data[index], key: uuidv4() };
          //   } else {
          //     return item;
          //   }
          // });
          this.fileList = [...this.fileList, ...res.data.data].filter(item => !Object.prototype.hasOwnProperty.call(item, 'file')).map(item => ({ ...item, key: uuidv4() }));
          console.log(this.fileList);
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.fileList);
        });
      } else {
        let content = file.file;
        let formData = new FormData();
        formData.append('file', content);
        upload(formData).then(res => {
          this.uploadFileFlag = false;
          this.fileList = this.fileList?.map(item => {
            if (Object.prototype.hasOwnProperty.call(item, 'file')) {
              return { ...res.data.data, key: uuidv4() };
            } else {
              return item;
            }
          });
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.fileList);
        });
      }
    },
    beforeDelete(file, item) {
      this.fileList = this.fileList.filter(item => {
        if (Object.prototype.hasOwnProperty.call(file, 'file')) {
          return item.key !== file.file.key;
        } else {
          return item.key !== file.key;
        }
      });
      this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.fileList);
    },
    onConfirm(data) {
      const date = new Date(data);
      const dateTime =
        date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate()) + ' ' + this.checkTime(date.getHours()) + ':' + this.checkTime(date.getMinutes());
      this.fieldsValue[`field${this.timeIndex}`] = dateTime;

      // 前人写的for循环嵌套vant-date改不动
      if (this.vanDateType === 'date') {
        const dateTime2 = date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate());
        this.fieldsValue[`field${this.timeIndex}`] = dateTime2;
      }

      // 兼容走草稿拿到详情的情况
      let id = this.$route.query?.instanceId || this.initialData.instanceId;
      if (id && this.modelName === '请假审批') {
        let fields = this.formData;

        let re = fields.find(itm => itm.label === '请假开始时间');
        let sInd = re.formId; // 动态配置开始时间

        let re2 = fields.find(itm => itm.label === '请假结束时间');
        let eInd = re2.formId;

        if (!this.startDate) {
          this.startDate = sInd;
        }
        if (!this.endDate) {
          this.endDate = eInd;
        }

        let re3 = fields.find(itm => itm.label === '请假类型');
        let cInd = 'field' + re3.formId;

        let o = JSON.parse(this.fieldsValue?.[cInd]);
        if (this.leaveCode === '') {
          this.leaveCode = o.code + '';
        }
      }

      // 兼容草稿公出和申请
      if (id && (this.modelName === '公出申请' || this.modelName === '出差申请')) {
        let fields = this.formData;

        let re = fields.find(itm => itm.label === '开始时间');
        let sInd = re.formId; // 动态配置开始时间

        let re2 = fields.find(itm => itm.label === '结束时间');
        let eInd = re2.formId;

        if (!this.startDate) {
          this.startDate = sInd;
        }
        if (!this.endDate) {
          this.endDate = eInd;
        }
      }

      if (this.startDate && this.endDate && this.leaveCode) {
        let start = this.fieldsValue[`field${this.startDate}`] + ':00';
        let end = this.fieldsValue[`field${this.endDate}`] + ':00';

        start = start.substring(0, 19);
        end = end.substring(0, 19);

        const params = {
          startDate: start,
          endDate: end,
          leaveCode: this.leaveCode,
          companyId: this.initialData.companyId
        };
        computeTime(params).then(res => {
          if (res.data.code === 0) {
            this.formData.map(item => {
              if (item.label === '时长') {
                this.fieldsValue[`${item.vModel}`] = res.data.data;
                this.$forceUpdate();
              }
            });
          }
        });

        computeTimeV2(params).then(res => {
          if (res.data.code === 0) {
            this.formData.map(item => {
              if (item.label === '请假天数') {
                this.fieldsValue[`${item.vModel}`] = res.data.data?.leaveDurationUnit;
                this.$forceUpdate();
              }
            });
          }
        });
      } else if (this.startDate && this.endDate && (this.modelName === '公出申请' || this.modelName === '出差申请')) {
        let start = this.fieldsValue[`field${this.startDate}`] + ':00';
        let end = this.fieldsValue[`field${this.endDate}`] + ':00';

        start = start.substring(0, 19);
        end = end.substring(0, 19);

        const params = {
          startDate: start,
          endDate: end,
          companyId: this.initialData.companyId
        };

        computeTimeV3(params).then(res => {
          if (res.data.code === 0) {
            this.formData.map(item => {
              if (item.label === '时长') {
                this.fieldsValue[`${item.vModel}`] = res.data.data;
                this.$forceUpdate();
              }
            });
          }
        });
      } else if (this.startDate && this.endDate && (this.kitValue === 3 || this.kitValue === 4)) {
        this.formData.map(item => {
          if (item.label === '时长') {
            const startDate = this.fieldsValue[`field${this.startDate}`];
            const endDate = this.fieldsValue[`field${this.endDate}`];
            const hour = new Date(endDate) - new Date(startDate);
            this.fieldsValue[`${item.vModel}`] = (hour / 3600 / 1000).toFixed(1);
            this.$forceUpdate();
          }
        });
      }
      this.showPicker = false;
    },
    onConfirmRangeTime(data) {
      const date = new Date(data);
      const dateTime =
        date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate()) + ' ' + this.checkTime(date.getHours()) + ':' + this.checkTime(date.getMinutes()) + ':00';
      this.fieldsValue[`field${this.timeIndex}`].push(dateTime);
      if (this.rangeStatus === 'start') {
        this.startTime = dateTime;
      } else {
        this.endTime = dateTime;
      }
      if (Date.parse(new Date(this.startTime)) > Date.parse(new Date(this.endTime))) {
        [this.startTime, this.endTime] = [this.endTime, this.startTime];
      }
      this.showRangePicker = false;
    },
    submit() {
      // 接口
      if (this.action === 'add') {
        this.submitLoading = true;
      }
      if (this.action === 'save') {
        this.saveDraftLoading = true;
      }
      const links = this.linkData.links.map((item, index) => {
        if (item.approvalMemberType === 'optional') {
          return { ...item, members: this.selectedList[`approve${index}`] };
        } else {
          return item;
        }
      });

      // 去掉↓抄送人逻辑
      // const copyLink = {
      //   members: this.selectedList["copy"],
      // };

      let cp = this.selectedList['copy'];
      cp ? (this.linkData.copyLink.members = this.cpmember.concat(this.selectedList['copy'])) : '';

      this.formData.forEach(item => {
        if (item.tagIcon === 'dept') {
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.selectedList[`dept${item.vModel}`]);
        }
        if (item.tagIcon === 'map') {
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.address);
        }
        if (item.tagIcon === 'mapList') {
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.addressList);
        }
        if (item.tagIcon === 'position') {
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.selectedList[`position${item.vModel}`]);
        }
        if (item.tagIcon === 'department') {
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.selectedList[`department${item.vModel}`]);
        }
        if (item.tagIcon === 'company') {
          this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.selectedList[`company${item.vModel}`]);
        }

        if (this.kitValue === 0 && item.isKit === 0 && (item.label === '请假开始时间' || item.label === '请假结束时间')) {
          let s1 = this.fieldsValue[`${item.vModel}`].substr(0, 16);
          s1 += ':00';
          this.fieldsValue[`${item.vModel}`] = s1; // 请假 后台校验了要秒
        }

        if (this.kitValue === 1 && item.isKit === 0 && item.label === '补卡时间') {
          let s1 = this.fieldsValue[`${item.vModel}`].substr(0, 16);
          s1 += ':00';
          this.fieldsValue[`${item.vModel}`] = s1; // 补卡 后台校验了要秒
        }
      });

      submitFormData({
        companyId: this.initialData.companyId,
        draftFlag: this.action === 'add' ? '1' : '0',
        fieldsStr: JSON.stringify(this.fieldsValue),
        modelId: this.initialData.modelId || this.modelId,
        links,
        // copyLink: this.selectedList["copy"] ? copyLink : this.linkData.copyLink,
        copyLink: this.linkData.copyLink, // 走抄送人累加
        instanceId: this.againSubmitFlag ? '' : this.initialData.instanceId || '',
        oldInstanceId: this.againSubmitFlag ? this.initialData.instanceId || '' : undefined // 查看原流程ID
      }).then(res => {
        if (this.action === 'add') {
          this.submitLoading = false;
        }
        if (this.action === 'save') {
          this.saveDraftLoading = false;
        }
        if (res.data.code === 0) {
          // window.location.href = "jsToOc://back";
          if (this.action === 'add') {
            Toast.success('提交成功');
          } else {
            Toast.success('保存成功');
          }
          setTimeout(() => {
            this.handleBack();
          }, 500);
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    save(status) {
      this.action = status;
      this.$refs.form.submit();
    },
    send(status) {
      this.action = status;
      this.$refs.form.submit();
    },
    selectConfirm(value) {
      const item = this.selectItem;
      if (this.kitValue === 0 && item.isKit === 0 && item.label === '请假类型') {
        let obj = {};
        this.columnValues.forEach(i => {
          if (i.holidayName === value) {
            obj = i;
          }
        });
        this.fieldsValue[`${item.vModel}`] = JSON.stringify(obj);
        this.selectValue = value;
        this.leaveCode = String(obj.code);
        if (this.leaveCode && this.startDate && this.endDate) {
          let start = this.fieldsValue[`field${this.startDate}`] + ':00';
          let end = this.fieldsValue[`field${this.endDate}`] + ':00';

          const params = {
            startDate: start,
            endDate: end,
            leaveCode: this.leaveCode,
            companyId: this.initialData.companyId
          };
          computeTime(params).then(res => {
            if (res.data.code === 0) {
              this.formData.map(item => {
                if (item.label === '时长') {
                  this.fieldsValue[`${item.vModel}`] = res.data.data;
                  this.$forceUpdate();
                }
              });
            }
          });

          computeTimeV2(params).then(res => {
            if (res.data.code === 0) {
              this.formData.map(item => {
                if (item.label === '请假天数') {
                  this.fieldsValue[`${item.vModel}`] = res.data.data?.leaveDurationUnit;
                  this.$forceUpdate();
                }
              });
            }
          });
        }
      } else {
        this.fieldsValue[`${item.vModel}`] = value;
        this.$forceUpdate();
      }
      // this.selectValue = value;
      this.showSelect = false;
      this.getLinks();
    },
    areaOnConfirm(values, item) {
      this.fieldsValue[`${item.vModel}`] = values
        .filter(item => !!item)
        .map(item => item.name)
        .join('/');
      this.showArea = false;
    },
    handleOptions(item) {
      function handlePushText(item) {
        for (let i = 0, len = item.length; i < len; i++) {
          let childs = item[i].children;
          item[i].text = item[i].label;
          if (childs && childs.length > 0) {
            handlePushText(childs);
          }
        }
        return item;
      }
      return handlePushText(item.options);
    },
    onFinish(selectedOptions, item) {
      this.show = false;
      this.fieldsValue[`${item.vModel}`] = selectedOptions.map(option => option.text).join('/');
    },
    validator(val) {
      if (!val) return false;
    },
    inputValidator(val) {
      if (!val) return false;
    },
    selectCopy() {
      // this.$router.push("select-copy");
      this.$store.commit('setStatus', 'copy');
      this.$router.push('/personnel-selection');
      // window.JsCallNative.showNativeTitle(false)
    },
    selectApprove(index) {
      this.$store.commit('setStatus', `approve${index}`);
      // this.$router.push("select-copy");
      this.$router.push('/personnel-selection');
      // let box1 = document.querySelector('.process-box');
    },
    deleteMember(item, number) {
      console.log(item);
      this.$store.commit('setCheckedList', {
        data: item,
        status: true,
        number
      });
      this.$forceUpdate();
    },
    handleTime(item) {
      this.showPicker = true;
      this.timeIndex = item.formId;
      if (item.label === '请假开始时间' || item.label === '开始时间') {
        this.startDate = item.formId;
      }
      if (item.label === '请假结束时间' || item.label === '结束时间') {
        this.endDate = item.formId;
      }

      this.vanDateType = 'datetime';
      if (item.label === '毕业时间') {
        this.vanDateType = 'date';
      }
    },
    handleRnageTime(item, status) {
      this.showRangePicker = true;
      this.timeIndex = item.formId;
      this.rangeStatus = status;
    },
    renderMember(item) {
      let str = '';
      item.members?.map(i => {
        if (Object.prototype.hasOwnProperty.call(i, 'position')) {
          if (i.position) {
            str += i.staffName + '(' + i.position + ')' + ' ';
          } else {
            str += i.staffName + ' ';
          }
        }
        if (Object.prototype.hasOwnProperty.call(i, 'roleName')) {
          if (i.roleName) {
            str += i.staffName + '(' + i.roleName + ')' + ' ';
          } else {
            str += i.staffName + ' ';
          }
        }
        if (!Object.prototype.hasOwnProperty.call(i, 'roleName') && !Object.prototype.hasOwnProperty.call(i, 'position')) {
          str += i.staffName + ' ';
        }
      });
      return str;
    },
    renderImg(item) {
      return item.members ? item.members[0]?.avatar : '';
    },
    getLinks() {
      const params = {
        companyId: this.initialData.companyId,
        modelId: this.initialData.modelId || this.modelId,
        fieldsStr: JSON.stringify(this.fieldsValue)
      };
      getApproveAndCopy(params).then(res => {
        if (res.data.code === 0) {
          this.linkData = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    selectDept(item) {
      this.$store.commit('setStatus', `dept${item.vModel}`);
      // this.$router.push("select-copy");
      this.$router.push('/personnel-selection');
    },
    handleDept(item) {
      let str = '';
      let _post = '';
      this.selectedList[`dept${item.vModel}`]?.forEach(itm => {
        str += itm.staffName ? itm.staffName + '/' : itm.name + '/';

        if (item.label === '离职员工') {
          _post += `${itm.post || itm.position || ''}/`; // 离职套件特殊操作
        }
      });

      if (_post && item.label === '离职员工') {
        let re = _post.slice(0, _post.length - 1); // 离职套件特殊操作
        this.$set(this.fieldsValue, 'field3', re || '');
      }
      return str.slice(0, str.length - 1);
    },
    handleBack() {
      this.fieldsValue = {};
      this.fileList = [];
      this.setInitialData({
        modelId: '',
        instanceId: ''
      });
      if (this.fromApp) {
        window.location.href = 'jsToOc://back';
      } else {
        this.$store.commit('setFromApp', true);
        this.$router.push('/workReport');
      }
    },
    handleMap() {
      this.$router.push('/map-view');
    },

    changeSwitch(e) {
      this.switchFlag = e;
    },
    handleVisible(avatar) {
      let str = avatar ? avatar.slice(0, 4) : '';
      return str === 'http';
    },
    renderName(name) {
      let str = '';
      if (name) {
        if (name.length === 1) {
          str = name;
        }
        if (name.length > 1) {
          str = name.substr(-2, 2);
        }
      }
      return str;
    },
    renderMemberName(item) {
      let str = '';
      let name = item.members ? item.members[0]?.staffName : '';
      if (name) {
        if (name.length === 1) {
          str = name;
        }
        if (name.length > 1) {
          str = name.substr(-2, 2);
        }
      }
      return str;
    },
    // handleStepBoxStyle(index) {
    //   return {
    //     "padding-bottom":
    //       index === this.linkData.links.length - 1 ? "0" : "34px",
    //   };
    // },
    handleArrow(index) {
      let length = this.selectedList[`approve${index}`]?.length;
      if (length === 0 || !this.selectedList[`approve${index}`]) {
        return;
      } else {
        return {
          top: length < 4 ? `${parseInt(length / 4 + 1) * 80 - 20}px` : `${parseInt(length / 4 + 1) * 80 - 42}px`
        };
      }
    },
    handleSelectNumber(item, index) {
      // 处理是几人依次审批
      let length = this.selectedList[`approve${index}`]?.length || item.members?.length;
      return length > 0 ? (item.userType === 'approver' ? `${length}人依次审批` : `${length}人依次办理`) : '';
    },
    handleStrip(item, index) {
      let length = this.selectedList[`approve${index}`]?.length || item.members?.length || 0;
      if (length === 0) {
        return;
      } else {
        return {
          height: length < 5 ? `1.5rem` : `${Math.ceil(length / 4) * 1.16 + 1.5}rem`
        };
      }
    },
    async handleSelectValue(item) {
      this.selectItem = item;
      this.showSelect = true;
      if (this.kitValue === 0 && item.isKit === 0 && item.label === '请假类型') {
        const params = {
          companyId: this.initialData.companyId
        };
        await getHoliday(params).then(res => {
          if (res.data.code === 0) {
            this.columns = res.data.data.map(item => item.holidayName);
            this.columnValues = res.data.data;
          } else {
            Toast.fail(res.data.msg);
          }
        });
      } else {
        this.columns = item.options.map(item => item.value);
        this.columnValues = item.options.map(item => item.value);
      }
    },
    formatSize(item) {
      return formatSize(item.size, 2);
    },
    deleteFile(item, i) {
      this.fileList = this.fileList.filter(c => c.key !== i.key);
      this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.fileList);
      console.log(this.fieldsValue[`${item.vModel}`]);
    },
    renderFileName(item) {
      let str = item?.url?.slice(item?.url?.lastIndexOf('.'));
      let name = item?.fileName || item?.name;
      return name + str;
    },
    selectPosition(item) {
      this.$store.commit('setStatus', `position${item.vModel}`);
      this.$router.push('select-copy');
    },
    handlePosition(item) {
      let str = '';
      this.selectedList[`position${item.vModel}`]?.forEach(item => {
        str += item.name + '/';
      });
      return str.slice(0, str.length - 1);
    },
    selectDepartment(item) {
      this.$store.commit('setStatus', `department${item.vModel}`);
      this.department = item;
      this.$router.push('select-copy');
    },
    handleDepartment(item) {
      let str = '';
      this.selectedList[`department${item.vModel}`]?.forEach(item => {
        str += item.officeName + '/';
      });
      return str.slice(0, str.length - 1);
    },
    selectCompany(item) {
      this.$store.commit('setStatus', `company${item.vModel}`);
      this.$router.push('select-copy');
    },
    handleCompany(item) {
      let str = '';
      this.selectedList[`company${item.vModel}`]?.forEach(item => {
        str += item.name + '/';
        this.$store.commit('setApplyCompanyId', item.id);
      });
      return str.slice(0, str.length - 1);
    },
    // 检查文件名是否相同
    checkSameFileName(fileList, file) {
      let flag = false;
      fileList.forEach(item => {
        if (file.fileName == item.fileName) {
          flag = true;
          return;
        }
      });
      return flag;
    },
    checkRouteCompanyId() {
      let route = this.$route;
      if (route.query && route.query.companyId) {
        let q = route.query;
        this.routeCompanyId = q.companyId; // 兼容从其他地方进来参数丢失
        this.routeToken = q.token;
        this.routeNick = decodeURIComponent(q.name);

        let i = this.initialData;
        if (!i.companyId) {
          this.setInitialData({
            companyId: this.routeCompanyId,
            token: this.routeToken,
            name: this.routeNick
          });
        }
      }
    }
  },
  created() {
    if (this.$route.query?.modelId) {
      this.setInitialData({
        modelId: this.$route.query?.modelId
      });
    }
    if (this.$route.query?.instanceId) {
      this.setInitialData({
        instanceId: this.$route.query?.instanceId
      });
    }

    this.checkRouteCompanyId();

    // 从别的地方选文件进入app
    window['uploadFileH5'] = result => {
      if (result) {
        this.formData.map(item => {
          if (item.tagIcon === 'upload') {
            let fileList = [result].map(item => ({ ...item, key: uuidv4() }));
            if (this.fileList.length > 0) {
              if (!this.checkSameFileName(this.fileList, result)) {
                this.fileList = [...this.fileList, ...fileList];
              }
            } else {
              this.fileList = fileList;
            }
            this.fieldsValue[`${item.vModel}`] = JSON.stringify(this.fileList);
          }
        });
      }
    };
    this.currentDate = Object.prototype.hasOwnProperty.call(this.initialData, 'applyTime') ? new Date(Number(this.initialData.applyTime)) : new Date();
  },
  async mounted() {
    // defaultData 可以将默认formData覆盖到data中
    await this.getData();
  },
  beforeRouteEnter(to, from, next) {
    // ...
    if (from.path === '/workReport') {
      next(vm => {
        vm.fieldsValue = {};
        vm.fileList = [];
      });
    } else {
      next();
    }
  },
  beforeDestroy() {},
  activated() {
    if (this.$route.query?.modelId) {
      this.setInitialData({
        modelId: this.$route.query?.modelId
      });
    }
    if (this.$route.query?.instanceId) {
      this.setInitialData({
        instanceId: this.$route.query?.instanceId
      });
    }

    this.checkRouteCompanyId();

    // this.getData();
    this.$forceUpdate();
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;

  background: #f9f9f9;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-bottom: 1.81rem;
  // padding-top: 1.71rem;
  // box-sizing: border-box;
}
.content {
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: scroll;

  // padding-bottom: 1.81rem;
  // padding-top: 1.71rem;
  // box-sizing: border-box;
  // overflow: auto;
}
.apply-tab {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: relative;
  // position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  flex-flow: row nowrap;
  justify-content: space-between;
  // top: 0;
  // left: 0;
}
.apply-tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.apply-container {
  width: 100vw;
  height: 1.31rem;
  font-size: 0.45rem;
  line-height: 1.31rem;
  background: white;
  font-weight: 500;
  border-top: 1px solid #f3f3f3;
  box-shadow: 0px 2px 4px 0px #f2f3f5;
  display: flex;
  justify-content: space-between;
}
.apply-container span {
  margin-left: 0.5rem;
}
.form-container {
  width: 9.25rem;
  background: white;
  overflow: auto;
  /* padding-bottom: 10vh; */
  /* margin: 3rem auto 1rem; */
  padding: 0.16rem 0 0.43rem 0.43rem;
  margin: 0.43rem auto;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
}
.van-cell--required::before {
  left: 0;
}
.process-info {
  width: 9.25rem;
  background: white;
  font-size: 16px;
  margin: auto 0.2rem 0.7rem 0.6rem;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  overflow: auto;
}
.process-box {
  width: 9.25rem;
  background: #ffffff;
  padding: 0.43rem;
  border-radius: 8px;
  margin: 0.43rem auto;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
  height: auto;
}
.process-end {
  min-height: 40px !important;
}
.process-start {
  display: flex;
  /* min-height: 77px; */
  /* min-height: 80px; */
  justify-content: space-between;
  position: relative;
}
.process-arrow {
  width: 6px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 45px;
  left: 16px;
}
.process-arrow :first-child {
  width: 2px;
  height: 24px;
  background: #00ca7b;
}
.process-arrow :last-child {
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  border-left: 3px solid transparent;
  border-top: 4px solid #00ca7b;
}
.approve-list {
  display: flex;
  /* flex-direction: row-reverse; */
  flex-wrap: wrap;
  text-align: center;
  width: 4.8rem;
}
.member-img {
  width: 1rem;
  height: 1rem;
  /* margin-right: 8px; */
  border-radius: 4px;
}
.member-name {
  /* width: 0.8rem; */
  height: 0.37rem;
  font-size: 0.27rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.37rem;
  text-align: center;
  font-size: 12px;
  word-break: break-word;
}

.selected-member {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1rem;
  position: relative;
  margin-right: 0.2rem;
  margin-bottom: 0.3rem;
}
.member-plus {
  /* width: 1.07rem;
  height: 1.07rem;
  background: rgb(255, 255, 255); */
  /* border: 1px solid rgb(196, 199, 213); */
  border-radius: 4px;
  font-size: 1.07rem;
  /* margin-right: 8px; */
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
}
/* .member-plus img {
  width: 0.5rem;
  height: 0.5rem;
} */
.copy-box {
  width: 9.25rem;
  background: #ffffff;
  padding: 0.43rem;
  border-radius: 8px;
  margin: 0.43rem auto;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
  margin-bottom: 0.4rem;
}
.copy-list {
  display: flex;
  /* height: 40px; */
  /* position: relative; */
  flex-wrap: wrap;
}

/* .copy-list {
  width: 9.25rem;
  min-height: 2rem;
  background: white;
  font-size: 16px;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  margin: 0.2rem 0.1rem 0.2rem 0.6rem;
  overflow: auto;
  border-radius: 10px;
  box-shadow: 0 0 15px rgb(0 0 0 / 10%);
} */
/* .van-step /deep/.van-step__title{
  display: flex;
  align-items:center;
} */
.van-step-box {
  display: flex;
  /* align-items: center; */
  flex-wrap: wrap;
  align-items: baseline;
  text-align: center;
}
.van-step-copy {
  display: flex;
  text-align: center;
  align-items: baseline;
  flex-wrap: wrap;
}
.button-box {
  width: 100vw;
  height: 1.81rem;
  position: fixed;
  left: 0;
  bottom: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  background: #ffffff;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-shadow: 0px -2px 4px 0px #efefef;
}
.button-box .button1 {
  width: 3.99rem;
  height: 1.17rem;
  background: #ffffff;
  border-radius: 0.21rem;
  border: 0.03rem solid #666666;
}
.button-box .button2 {
  width: 3.99rem;
  height: 1.17rem;
  background: #1584ff;
  border-radius: 0.21rem;
  color: #ffffff;
  box-shadow: 0rem 0.05rem 0.21rem 0rem #80bcff;
  border: none;
}
.van-cell {
  padding-left: 6px;
  border-bottom: 1px solid #f3f3f3;
}
.van-cell /deep/ .van-field__label {
  width: auto !important;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
.van-cell /deep/ .van-switch-right {
  margin-left: 3.5rem;
}
.van-cell /deep/ .van-field__control--custom {
  display: flex;
  justify-content: flex-end;
}
/* .van-cell:last-child{
  border-bottom: none;
} */
/* .selected-member {
  display: flex;
  flex-direction:column;
  align-items: center;
  width: 40px;
  height: 40px;
  position: relative;
} */
.van-cell /deep/ .van-field__control {
  text-align: right;
  /* margin-right: 0.34rem; */
}
.member-delete {
  color: white;
  background: red;
  border-radius: 0.4rem;
  width: 0.4rem;
  height: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -0.1rem;
  left: 0.7rem;
}
.copy-alreadySelect {
  /* margin-left: 0.2rem; */
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.2rem;
}
.copy-member {
  width: 1rem;
  margin-right: 0.2rem;
  margin-bottom: 0.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.approve-alreadySelect {
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.2rem;
  width: 6rem;
  flex-direction: row-reverse;
}
.staffNameBox {
  width: 1rem;
  height: 1rem;
  background: #1584ff;
  color: white;
  text-align: center;
  line-height: 1rem;
  border-radius: 4px;
  font-size: 12px;
}
.circular {
  width: 0.3rem;
  height: 0.3rem;
  background-color: #d9d9d9;
  border-radius: 50%;
  /* margin-top: 0.1rem; */
}
.circular1 {
  width: 0.3rem;
  height: 0.3rem;
  background-color: #d9d9d9;
  border-radius: 50%;
  /* margin-top: 0.1rem; */
}
.strip {
  width: 0.05rem;
  height: 1.5rem;
  margin-left: 0.12rem;
  background-color: #d9d9d9;
}
.member-bg {
  width: 1rem;
  height: 1rem;
  background: #1584ff;
  border-radius: 0.21rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 1rem;
  text-align: center;
  margin-right: 8px;
  position: absolute;
  right: 0px;
}
.select-number {
  height: 0.45rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #888888;
  line-height: 0.45rem;
  min-width: 2rem;
}
.copy-surround {
  display: flex;
  /* flex-direction: column; */
  flex-wrap: wrap;
}
.inputfield {
  display: block !important;
}
.inputfield /deep/.van-field__control {
  text-align: left !important;
}
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}
.annex-name {
  display: flex;
  /* justify-content: flex-start; */
  align-items: center;
}
.annex-button {
  width: 1.41rem;
  background: #ffffff;
  border-radius: 0.11rem;
  border: 0.03rem solid #1584ff;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1584ff;
  text-align: center;
  line-height: 0.7rem;
  height: 0.7rem;
}
.uploading_popup {
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
